// extracted by mini-css-extract-plugin
export default {"container":"Map--container--CJUaG","not-supported":"Map--not-supported--Xsq3i","notSupported":"Map--not-supported--Xsq3i"};